"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2349],{

/***/ 45635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ LDFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48876);
/* harmony import */ var src_app_globalStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(458);
/* harmony import */ var _Layout_HeadFoot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3702);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #cccccc;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 14px;\n\n  @media (max-width: ",
        ") {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LDFooter = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_HeadFoot__WEBPACK_IMPORTED_MODULE_4__/* .LDFooterWrapper */ .cD, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterText, {
            children: "VIENNA HYPERTEXT INC \xa9 2023"
        })
    });
};
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-22469b83-0"
})(_templateObject(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_3__/* .DEVICE.small */ .T.small);


/***/ }),

/***/ 84366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KS": function() { return /* binding */ HeaderLink; },
/* harmony export */   "hn": function() { return /* binding */ LDHeader; },
/* harmony export */   "jl": function() { return /* binding */ JobPostHeader; },
/* harmony export */   "lY": function() { return /* binding */ LDHeaderWithBreadcrums; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40974);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48876);
/* harmony import */ var src_app_globalStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(458);
/* harmony import */ var src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91865);
/* harmony import */ var src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47209);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30440);
/* harmony import */ var _Layout_HeadFoot__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3702);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 100%;\n  margin-bottom: 0px;\n  margin-top: 0px;\n\n  @media (max-width: ",
        ") {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100px;\n\n  @media (max-width: ",
        ") {\n    font-size: 12px;\n    width: 70px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #904d4d;\n  cursor: pointer;\n  display: block;\n  font-size: 10px;\n  margin-right: 20px;\n  text-align: right;\n  transition: opacity 200ms ease;\n  text-decoration: none;\n  -webkit-transition: opacity 200ms ease;\n  :hover {\n    color: #494949;\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










function LDHeader(param) {
    var text = param.text, leftItem = param.leftItem, rightItem = param.rightItem;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_HeadFoot__WEBPACK_IMPORTED_MODULE_9__/* .LDHeaderWrapper */ .Td, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemWrapper, {
                children: leftItem
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageTitleText, {
                children: text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemWrapper, {
                children: rightItem
            })
        ]
    });
}
function LDHeaderWithBreadcrums(param) {
    var text = param.text, textLink = param.textLink, leftItem = param.leftItem, rightItem = param.rightItem, stem = param.stem, stemLink = param.stemLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_HeadFoot__WEBPACK_IMPORTED_MODULE_9__/* .LDHeaderWrapper */ .Td, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemWrapper, {
                children: leftItem
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PageTitleText, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        passHref: true,
                        href: stemLink || src_lib_constants__WEBPACK_IMPORTED_MODULE_8__/* .AppRoutes.Meta */ .$w.Meta,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__/* .StyledLink */ .Fg, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .BreadcrumStem */ .Zh, {
                                children: stem || "VIENNA /"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        passHref: true,
                        href: textLink,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__/* .StyledLink */ .Fg, {
                            children: text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ItemWrapper, {
                children: rightItem
            })
        ]
    });
}
function JobPostHeader(param) {
    var jobTitle = param.jobTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LDHeader, {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: src_lib_constants__WEBPACK_IMPORTED_MODULE_8__/* .AppRoutes.Jobs */ .$w.Jobs,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBreadcrum */ .tU, {
                        children: "JOBS /"
                    })
                }),
                " ",
                jobTitle
            ]
        }),
        leftItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: react_device_detect__WEBPACK_IMPORTED_MODULE_4__/* .isElectron */ .d ? "/index.html" : "/",
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HeaderLink, {
                style: {
                    textAlign: "left",
                    marginLeft: "20px"
                },
                children: "HOME"
            })
        })
    });
}
var PageTitleText = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-b041191e-0"
})(_templateObject(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_5__/* .DEVICE.small */ .T.small);
var ItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b041191e-1"
})(_templateObject1(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_5__/* .DEVICE.small */ .T.small);
var HeaderLink = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-b041191e-2"
})(_templateObject2());


/***/ }),

/***/ 91881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qB": function() { return /* binding */ LDSectionBlock; },
/* harmony export */   "sw": function() { return /* binding */ LDLinkBlock; },
/* harmony export */   "wm": function() { return /* binding */ LDExternalLinkBlock; },
/* harmony export */   "zB": function() { return /* binding */ LDBlock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(458);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: flex-start;\n  border: 1px solid #000;\n  color: #000;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding-bottom: 26px;\n  padding-left: 41px;\n  padding-right: 41px;\n  padding-top: 36px;\n  text-decoration: none;\n  width: 680px;\n\n  @media (max-width: ",
        ") {\n    width: 85%;\n  }\n  @media (max-width: ",
        ") {\n    padding-left: 36px;\n    padding-right: 36px;\n    padding-bottom: 19px;\n    padding-top: 33px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  height: 40px;\n  justify-content: center;\n  padding-top: 0;\n  padding-bottom: 0px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  cursor: pointer;\n  :hover {\n    background-color: #e1e1e1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: flex-start;\n  border: 1px solid #000;\n  color: #000;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding-bottom: 36px;\n  padding-left: 41px;\n  padding-right: 41px;\n  padding-top: 36px;\n  text-decoration: none;\n  width: 680px;\n  @media (max-width: ",
        ") {\n    width: 85%;\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LDBlock = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b0a044e7-0"
})(_templateObject(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium, src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.small */ .T.small);
var LDSectionBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlock).withConfig({
    componentId: "sc-b0a044e7-1"
})(_templateObject1());
var LDLinkBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlock).withConfig({
    componentId: "sc-b0a044e7-2"
})(_templateObject2());
var LDExternalLinkBlock = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-b0a044e7-3"
})(_templateObject3(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium, function(param) {
    var theme = param.theme;
    return theme.accent;
});


/***/ }),

/***/ 3702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ LDHeaderWrapper; },
/* harmony export */   "cD": function() { return /* binding */ LDFooterWrapper; }
/* harmony export */ });
/* unused harmony export HeadFoot */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(458);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background-color: transparent;\n  border: 1px solid #000;\n  display: flex;\n  flex-direction: row;\n  font-family: Inter, sans-serif;\n  height: 40px;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  width: 680px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 80px;\n\n  @media (max-width: ",
        ") {\n    margin-top: 40px;\n    width: 85%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: center;\n  margin-bottom: 80px;\n  margin-top: 20px;\n\n  @media (max-width: ",
        ") {\n    margin-bottom: 40px;\n    width: 85%;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var HeadFoot = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a06faa8d-0"
})(_templateObject());
var LDHeaderWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(HeadFoot).withConfig({
    componentId: "sc-a06faa8d-1"
})(_templateObject1(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium);
var LDFooterWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(HeadFoot).withConfig({
    componentId: "sc-a06faa8d-2"
})(_templateObject2(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium);


/***/ }),

/***/ 92377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ LDPageContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  color: #333;\n  display: flex;\n  flex-direction: column;\n  font-family: Inter, sans-serif;\n  line-height: 14px;\n  margin-top: 0px;\n  overflow-y: scroll;\n  flex-shrink: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LDPageContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ac616996-0"
})(_templateObject());


/***/ }),

/***/ 91865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ LDSectionBlockHeading; },
/* harmony export */   "GB": function() { return /* binding */ LDTableData; },
/* harmony export */   "Hk": function() { return /* binding */ LDCaption; },
/* harmony export */   "LL": function() { return /* binding */ LDRedText; },
/* harmony export */   "Mo": function() { return /* binding */ LDBlockQuote; },
/* harmony export */   "Ms": function() { return /* binding */ LDBlockUL; },
/* harmony export */   "UU": function() { return /* binding */ LDTable; },
/* harmony export */   "WU": function() { return /* binding */ LDSectionBlockHeadingLink; },
/* harmony export */   "Yf": function() { return /* binding */ LDBlockDate; },
/* harmony export */   "Zh": function() { return /* binding */ BreadcrumStem; },
/* harmony export */   "lV": function() { return /* binding */ LDBlockOLSmall; },
/* harmony export */   "nL": function() { return /* binding */ LDBlockHeading; },
/* harmony export */   "qx": function() { return /* binding */ LDBlockULSmall; },
/* harmony export */   "s1": function() { return /* binding */ LDBlockSubheading; },
/* harmony export */   "tC": function() { return /* binding */ LDVLink; },
/* harmony export */   "tU": function() { return /* binding */ LDBreadcrum; },
/* harmony export */   "wk": function() { return /* binding */ LDCode; },
/* harmony export */   "yA": function() { return /* binding */ LDTableHeader; },
/* harmony export */   "yC": function() { return /* binding */ LDBlockParagraph; }
/* harmony export */ });
/* unused harmony exports LDBlockSubSubheading, LDBlockPTest, LDBlockOL */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(458);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  margin-top: 0px;\n  text-align: left;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-top: 0px;\n  width: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #904d4d;\n  text-decoration: underline;\n  :hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #904d4d;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  margin-bottom: 0px;\n  margin-top: 0px;\n  padding-top: 9px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #333;\n  font-size: 14px;\n  padding-top: 2px;\n  padding-bottom: 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  margin-bottom: 0px;\n  margin-top: 0px;\n  padding-top: 9px;\n  font-style: italic;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 4px;\n  width: auto;\n  margin-block-end: 1em;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 4px;\n  width: auto;\n  margin-block-end: 1em;\n  color: #2d2d2d;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-style: italic;\n  line-height: 20px;\n  margin-top: 4px;\n  width: auto;\n  margin-block-end: 1em;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin: 4px 0px 0em 27px;\n  padding-left: 18px;\n  width: auto;\n\n  @media (max-width: ",
        ") {\n    margin-bottom: 0vw;\n    margin-left: 13%;\n    margin-right: 7vw;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 12px;\n  margin-bottom: 14px;\n  @media (max-width: ",
        ") {\n    margin-left: 6px;\n    margin-right: 7vw;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin: 4px 0px 0em 27px;\n  padding-left: 18px;\n  width: auto;\n\n  @media (max-width: ",
        ") {\n    margin-bottom: 0vw;\n    margin-left: 13%;\n    margin-right: 7vw;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 12px;\n  margin-bottom: 14px;\n  @media (max-width: ",
        ") {\n    margin-left: 6px;\n    margin-right: 7vw;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #cccccc;\n  font-size: 12px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  background-color: #e3e3e3;\n  border-radius: 3px;\n  color: #24292e;\n  font-family: "IBM Plex Mono", Consolas, Liberation Mono, Menlo, Courier, monospace;\n  font-size: 85%;\n  margin: 0;\n  padding: 0.2em 0.4em;\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #904d4d;\n  text-decoration: none;\n  :hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #904d4d;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #cccccc;\n  cursor: pointer;\n  :hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  width: 300px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 5px;\n  border: solid 1px #777;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 5px;\n  border: solid 1px #777;\n  background-color: lightblue;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}


/* ------------------ Headings ------------------ */ var LDBlockHeading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-4d482c8a-0"
})(_templateObject());
var LDSectionBlockHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlockHeading).withConfig({
    componentId: "sc-4d482c8a-1"
})(_templateObject1());
var LDSectionBlockHeadingLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDSectionBlockHeading).withConfig({
    componentId: "sc-4d482c8a-2"
})(_templateObject2());
var LDBlockSubheading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-4d482c8a-3"
})(_templateObject3());
var LDBlockDate = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlockSubheading).withConfig({
    componentId: "sc-4d482c8a-4"
})(_templateObject4());
var LDBlockSubSubheading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-4d482c8a-5"
})(_templateObject5());
/* ------------------ Body ------------------ */ var LDBlockParagraph = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-4d482c8a-6"
})(_templateObject6());
var LDBlockPTest = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlockParagraph).withConfig({
    componentId: "sc-4d482c8a-7"
})(_templateObject7());
var LDBlockQuote = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlockParagraph).withConfig({
    componentId: "sc-4d482c8a-8"
})(_templateObject8());
var LDBlockUL = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-4d482c8a-9"
})(_templateObject9(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium);
var LDBlockULSmall = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlockUL).withConfig({
    componentId: "sc-4d482c8a-10"
})(_templateObject10(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium);
var LDBlockOL = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
    componentId: "sc-4d482c8a-11"
})(_templateObject11(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium);
var LDBlockOLSmall = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LDBlockOL).withConfig({
    componentId: "sc-4d482c8a-12"
})(_templateObject12(), src_app_globalStyles__WEBPACK_IMPORTED_MODULE_1__/* .DEVICE.medium */ .T.medium);
var LDCaption = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4d482c8a-13"
})(_templateObject13());
var LDCode = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].code.withConfig */ .ZP.code.withConfig({
    componentId: "sc-4d482c8a-14"
})(_templateObject14());
/* ------------------ Inline ------------------ */ var LDVLink = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-4d482c8a-15"
})(_templateObject15());
var LDRedText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4d482c8a-16"
})(_templateObject16());
var LDBreadcrum = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4d482c8a-17"
})(_templateObject17());
var BreadcrumStem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4d482c8a-18"
})(_templateObject18(), function(props) {
    return props.theme.text.subtle;
});
/* ------------------ Table ------------------ */ var LDTable = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-4d482c8a-19"
})(_templateObject19());
var LDTableData = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    componentId: "sc-4d482c8a-20"
})(_templateObject20());
var LDTableHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    componentId: "sc-4d482c8a-21"
})(_templateObject21());


/***/ })

}]);